import {debounce} from '@utils/debounce';

type AnyFn = (...args: unknown[]) => void;

const initResponsiveTables = (): void => {
    // Throttle that guarantees the last call is executed
    const customThrottle = <F extends AnyFn>(fn: F, limit: number): F => {
        let inThrottle = false;
        let lastFn: F | null = null;

        const throttled = function (this: unknown, ...args: Parameters<F>) {
            if (!inThrottle) {
                fn.apply(this, args);
                inThrottle = true;
                window.setTimeout(() => {
                    inThrottle = false;
                    if (lastFn) {
                        lastFn.apply(this, args);
                        lastFn = null;
                    }
                }, limit);
            } else {
                lastFn = fn;
            }
        };

        return throttled as F;
    };

    const showTableFade = (el: HTMLElement): boolean =>
        el.scrollWidth > el.clientWidth &&
        el.scrollLeft + el.clientWidth < el.scrollWidth - 1; // avoid off-by-1

    const toggleTableFade = (container: HTMLElement): void => {
        const tableWrapper = container.querySelector<HTMLElement>(".table-wrapper__scroll-container");
        if (!tableWrapper) {
            return;
        }

        if (showTableFade(tableWrapper)) {
            container.classList.add("table-wrapper--has-overflow");
        } else {
            container.classList.remove("table-wrapper--has-overflow");
        }
    };

    const containers = document.querySelectorAll<HTMLElement>(".table-wrapper");

    containers.forEach((container) => {
        const tableWrapper = container.querySelector<HTMLElement>(".table-wrapper__scroll-container");
        if (!tableWrapper) {
            return;
        }

        const throttledToggle = customThrottle(() => toggleTableFade(container), 50);
        tableWrapper.addEventListener("scroll", throttledToggle, {passive: true});
    });

    const updateAllTables = (): void => {
        containers.forEach((c) => toggleTableFade(c));
    };

    window.addEventListener(
        "resize",
        debounce(updateAllTables, 50),
        {
            passive: true,
        },
    );

    updateAllTables();
};

initResponsiveTables();